import { Grid } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import GddControls from "../../components/gdd-controls/GddControls";
import GddDialog from "../../components/gdd-dialog/GddDialog";
import GddDialogTitle from "../../components/gdd-dialog/GddDialogTitle";
import FlightDataIcon from "../../icons/param-mapping/FlightDataIcon";
import useAxios from "../../api/useAxios";

function SarDataDetails(props) {
    const {
        open,
        setOpen,
        addOrEdit,
        values,
        setValues,
        setErrors,
        errors,
        handleInputChange,
        resetForm,
        validate,
        editMode,
        isAdmin,
        textOutShow,
        handleShow,
    } = props;

    const { ENDPOINTS, createApiEndPoint, axiosApiInstance } = useAxios();

    const iconType = <FlightDataIcon iconSize="medium" />;
    const dlgTitle = (
        <GddDialogTitle
            title={editMode ? "Edit SAR Playback" : "Create New SAR Playback"}
            titleIcon={iconType}
        />
    );

    const autoCSelectedParams = useRef();
    
    const [redactionTypes, setRedactionTypes] = useState([]);
    const [airlines, setAirlines] = useState([]);
    const [dataFrames, setDataFrames] = useState([]);
    const [channelsToList, setChannelsToList] = useState([]);
    const [paramsToList, setParamsToList] = useState([]);
    
    const clearParamSelection = () => {
        const autoCRefs = [autoCSelectedParams];

        autoCRefs.forEach((item) => {
            const ele = item.current;

            if (ele) {
                const clearBtn = ele.getElementsByClassName(
                    "MuiAutocomplete-clearIndicator"
                )[0];
                if (clearBtn) {
                    clearBtn.click();
                }
            }
        });
    };

    useEffect(() => {
        if (values.mapJson !== undefined && values.mapJson !== "") {
            let userObj = JSON.parse(values.mapJson, item => {
                values.selectedChannel = item.Channel
            });            
        }
    });

    useEffect(() => {
        createApiEndPoint(ENDPOINTS.REDACTIONTYPE)
            .fetchAll(`getKeyValuePairs?sarTypes=${1}`)
            .then((res) => {
                const redactionTypesData = res.data;
                let redactionTypeOptions = redactionTypesData
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((item) => ({
                        id: item.id,
                        title: item.name,
                    }));
                setRedactionTypes(redactionTypeOptions);
            })
            .catch((err) => console.log(err));

        if (isAdmin) {
            createApiEndPoint(ENDPOINTS.AIRLINE)
                .fetchAll("getKeyValuePairs")
                .then((res) => {
                    const airlinesToDisplay = res.data;
                    let airlineOptions = airlinesToDisplay
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((item) => ({
                            id: item.id,
                            title: item.name,
                        }));
                    setAirlines(airlineOptions);
                })
                .catch((err) => console.log(err));
            setDataFrames([]);
        }
    }, []);

    useEffect(() => {
        createApiEndPoint(ENDPOINTS.DATAFRAME)
            .fetchAll(
                `getSelectListDtoByAirlineAndDataFrameType?dataIn=${values.airlineId}&dataIn=7`
            )
            .then((res) => {
                const dataFramesData = res.data;
                let dataFramesOptions = dataFramesData
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((item) => ({
                        id: item.id,
                        title: item.name,
                    }));
                setDataFrames(dataFramesOptions);
            })
            .catch((err) => console.log(err));

        setChannelsToList([]);
    }, [values.airlineId]);

    useEffect(() => {
        if (values.dataFrameId > 0) {
            createApiEndPoint(ENDPOINTS.DATAFRAME)
                .fetchAll(`getSarChannelsFromDataFrame?dataFrameId=${values.dataFrameId}`)
                .then((res) => {
                    const channelsToDisplay = res.data;
                    if (channelsToDisplay) {
                        let channelsList = channelsToDisplay
                            .sort((a, b) => (a.number > b.number ? 1 : -1))
                            .map((item) => ({
                                id: item.number,
                                title: item.name,
                            }));
                        setChannelsToList(channelsList);
                    } else {
                        setChannelsToList([]);
                    }
                })
                .catch((err) => console.log(err));
        } else {
            setChannelsToList([]);
        }        
    }, [values.dataFrameId]);

    useEffect(() => {
        if (values.dataFrameId > 0 && values.selectedChannel !== "") {
            createApiEndPoint(ENDPOINTS.DATAFRAME)
                .fetchAll(`getSarMnemonicsFromDataFrame?dataFrameId=${values.dataFrameId}&sarChannelNumber=${values.selectedChannel}`)
                .then((res) => {
                    const paramsToDisplay = res.data;
                    if (paramsToDisplay) {
                        let paramsList = paramsToDisplay
                            .sort((a, b) => (a.mnemonic > b.mnemonic ? 1 : -1))
                            .map((item) => ({
                                id: item.mnemonic,
                                label: item.mnemonic,
                                value: item.mnemonic
                            }));
                        setParamsToList(paramsList);
                    } else {
                        setParamsToList([]);
                    }
                })
                .catch((err) => console.log(err));
        } else {
            setParamsToList([]);
        }
    }, [values.dataFrameId, values.selectedChannel]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            addOrEdit(values, editMode);
        }
    };

    //const handleOnImport = () => {
    //    setOpen(false);
    //};

    const getLookupData = () => {
        return paramsToList.map((item) => item.label);
    };

    return (
        <div>
            <GddDialog
                title={dlgTitle}
                open={open}
                // maxWidth="lg"
                setOpen={setOpen}
                handleSubmit={handleSubmit}
                resetForm={resetForm}
            >
                <Grid
                    container
                    rowSpacing={2}
                    columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                >
                    <Grid item xs={12}>
                        <GddControls.GddTextField
                            fullWidth={true}
                            name="name"
                            variant="outlined"
                            label="Name"
                            required={true}
                            value={values.name}
                            onChange={handleInputChange}
                            error={errors.name}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <GddControls.GddTextField
                            fullWidth={true}
                            name="description"
                            label="Description"
                            required={false}
                            value={values.description}
                            onChange={handleInputChange}
                            error={errors.description}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <GddControls.GddSelect
                            fullWidth={true}
                            name="conversionTypeId"
                            label="Conversion Type"
                            required={true}
                            options={redactionTypes}
                            value={values.conversionTypeId}
                            onChange={(e) => {
                                handleShow(e.target.value);
                                handleInputChange(e);
                            }}
                            error={errors.conversionTypeId}
                        />
                    </Grid>
                    {isAdmin && (
                        <Grid item xs={12}>
                            <GddControls.GddSelect
                                fullWidth={true}
                                name="airlineId"
                                label="Airline"
                                required={true}
                                options={airlines}
                                value={values.airlineId}
                                onChange={(e) => {
                                    clearParamSelection();
                                    setTimeout(() => {
                                        handleInputChange(e);
                                    }, 100);
                                }}
                                error={errors.airlineId}
                            />
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        <GddControls.GddSelect
                            fullWidth={true}
                            name="dataFrameId"
                            label="Data Frame/SAR Map"
                            required={true}
                            options={dataFrames}
                            value={values.dataFrameId}
                            onChange={(e) => {
                                clearParamSelection();
                                handleInputChange(e);
                            }}
                            error={errors.dataFrameId}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <GddControls.GddSelect
                            fullWidth={true}
                            name="selectedChannel"
                            label="SAR Channels"
                            required={true}
                            options={channelsToList}
                            value={values.selectedChannel}
                            onChange={(e) => {
                                clearParamSelection();
                                handleInputChange(e);
                            }}
                            error={errors.selectedChannel}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <GddControls.GddMultiSelect
                            autoCRef={autoCSelectedParams}
                            items={paramsToList}
                            required={true}
                            // getOptionDisabled={getOptionDisabled}
                            label="Select Parameters"
                            placeholder="Parameters"
                            selectAllLabel="Select all"
                            onChange={(vals) => {
                                let evt = {
                                    target: {
                                        name: "redactedParams",
                                        value: [...vals],
                                    },
                                };
                                handleInputChange(evt);
                            }}
                            values={values.redactedParams}
                            error={errors.redactedParams}
                            noOptionsText="No parameters to list"
                            //includeImportOption={true}
                            //onImport={handleOnImport}
                        />
                    </Grid>
                </Grid>
            </GddDialog>
        </div>
    );
}

export default SarDataDetails;
